import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const warehouseRouter: RouteRecordRaw = {
    path: '/warehouse',
    component: Layout,
    redirect: 'noredirect',
    meta: {
        icon: 'el-icon-discount',
        title: '仓库管理'
    },
    children: [
        {
            path: '/warehouse/warehouseDictionary',
            component: () => import("@/views/main/warehouse/warehouseDictionary/warehouseDictionary.vue"),
            name: 'warehouseDictionary',
            meta: {
                title: '仓库字典'
            }
        },
        {
            path: '/warehouse/areaInfo',
            component: () => import("@/views/main/warehouse/areaInfo/areaInfo.vue"),
            name: 'areaInfo',
            meta: {
                title: '库区管理'
            }
        },
        {
            path: '/warehouse/AssemblyWorkshop',
            component: () => import("@/views/main/warehouse/AssemblyWorkshop/AssemblyWorkshop.vue"),
            name: 'AssemblyWorkshop',
            meta: {
                title: '组装车间'
            }
        },        
        {
            path: '/warehouse/entranceExit',
            component: () => import("@/views/main/warehouse/entranceExit/entranceExit.vue"),
            name: 'entranceExit',
            meta: {
                title: '库口管理'
            }
        },        
        {
            path: '/warehouse/storageInfo',
            component: () => import("@/views/main/warehouse/storageInfo/storageInfo.vue"),
            name: 'storageInfo',
            meta: {
                title: '库位管理'
            }
        },
        {
            path: '/warehouse/carrierInfo',
            component: () => import("@/views/main/warehouse/carrierInfo/carrierInfo.vue"),
            name: 'carrierInfo',
            meta: {
                title: '容器管理'
            }
        },

        {
            path: '/warehouse/materialInfo',
            component: () => import("@/views/main/warehouse/materialInfo/materialInfo.vue"),
            name: 'materialInfo',
            meta: {
                title: '物料管理'
            }
        },
        {
            path: '/warehouse/callagv',
            component: () => import("@/views/main/warehouse/callagv/callagv.vue"),
            name: 'callagv',
            meta: {
                title: '站点管理'
            }
        },
        {
            path: '/warehouse/equipmentInfo',
            component: () => import('@/views/main/warehouse/equipmentInfo/equipmentInfo.vue'),
            name: 'equipmentInfo',
            meta: {
                title: '设备管理'
            }
        },
        {
            path: '/warehouse/projectManagement',
            component: () => import("@/views/main/warehouse/projectManagement/projectManagement.vue"),
            name: 'projectManagement',
            meta: {
                title: '项目管理'
            }
        },
        {
            path: '/warehouse/wareSite',
            component: () => import("@/views/main/warehouse/wareSite/wareSite.vue"),
            name: 'wareSite',
            meta: {
                title: '站点管理'
            }
        },
        {
            path: '/warehouse/evaluatesHowVendor',
            component: () => import("@/views/main/warehouse/evaluatesHowVendor/evaluatesHowVendor.vue"),
            name: 'evaluatesHowVendor',
            meta: {
                title: '供应商账号'
            }
        },

        {
            path: '/warehouse/bintag',
            component: () => import("@/views/main/warehouse/bintag/bintag.vue"),
            name: 'bintag',
            meta: {
                title: '送货标签'
            }
        },





        {
            path: '/warehouse/warehouseInfo',
            component: () => import("@/views/main/warehouse/warehouseInfo/warehouseInfo.vue"),
            name: 'warehouseInfo',
            meta: {
                title: '仓库信息管理'
            }
        },
        {
            path: '/warehouse/shelfInfo',
            component: () => import("@/views/main/warehouse/shelfInfo/shelfInfo.vue"),
            name: 'shelfInfo',
            meta: {
                title: '货架信息管理'
            }
        },




























        // {
        //     path: '/warehouse/warehouseType',
        //     component: () => import("@/views/main/warehouse/warehouseType/warehouseType.vue"),
        //     name: 'warehouseType',
        //     meta: {
        //         title: '仓库类型管理'
        //     }
        // },


        // {
        //     path: '/warehouse/shelfType',
        //     component: () => import("@/views/main/warehouse/shelfType/shelfType.vue"),
        //     name: 'shelfType',
        //     meta: {
        //         title: '货架类型管理'
        //     }
        // },

        // {
        //     path: '/warehouse/storageType',
        //     component: () => import("@/views/main/warehouse/storageType/storageType.vue"),
        //     name: 'storageType',
        //     meta: {
        //         title: '库位类型管理'
        //     }
        // },

        // {
        //     path: '/warehouse/materialMaxType',
        //     component: () => import("@/views/main/warehouse/materialMaxType/materialMaxType.vue"),
        //     name: 'materialMaxType',
        //     meta: {
        //         title: '物料大类管理'
        //     }
        // },
        // {
        //     path: '/warehouse/materialType',
        //     component: () => import("@/views/main/warehouse/materialType/materialType.vue"),
        //     name: 'materialType',
        //     meta: {
        //         title: '物料类型管理'
        //     }
        // },

        // // {
        // //     path: '/warehouse/setLimit',
        // //     component: () => import("@/views/main/warehouse/setLimit/setLimit.vue"),
        // //     name: 'setLimit',
        // //     meta: {
        // //         title: '库存水位设置'
        // //     }
        // // },
        // {
        //     path: '/warehouse/setAge',
        //     component: () => import("@/views/main/warehouse/setAge/setAge.vue"),
        //     name: 'setAge',
        //     meta: {
        //         title: '库龄设置'
        //     }
        // },


        // {
        //     path: '/warehouse/equipmentType',
        //     component: () => import('@/views/main/warehouse/equipmentType/equipmentType.vue'),
        //     name: 'equipmentType',
        //     meta: {
        //         title: '设备类型定义'
        //     }
        // },

    ]
}

//仓库数据维护
export default warehouseRouter